import { render, staticRenderFns } from "./edited.vue?vue&type=template&id=476c8584"
import script from "./edited.vue?vue&type=script&lang=js"
export * from "./edited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports